import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import { Card, Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'

const RedemptionBrochure = (route) => {
    const[isUseGuideData,setIsUseGuideData]=useState([])
    const[isNoData,setIsNoData]=useState(false)
    const [loading, setLoading] = useState(true);

    const [modalVisiblePhoto, setModalVisiblePhoto] = useState(false);
    const [modalImagePhoto, setmodalImagePhoto] = useState('');
    // const [isLoading, setIsLoading] = useState(true);
    // const [imgData, setImgData] = useState([]);

    const [imgData, setImgData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
          setIsLoading(true);
          try {
            const token = localStorage.getItem("access_token");
            const res = await OtherService.getRedemptionCatalogue({}, token);
            setImgData(res.response);
          } catch (err) {
          } finally {
            setIsLoading(false);
          }
        };
    
        fetchData();
      }, []);

      function listRenderHandler({item, index}) {
        return (
          <img
            style={{objectFit: 'cover'}}
            src={item?.file_path}
            alt={item?.alt}
          />
        );
      }

    useEffect(() => {
      const userGuideDataFetch = async () => {
          try {
              const token = localStorage.getItem('access_token');
              const responseUserGuide = await OtherService.userGuideData();
  
              let rawHTML = responseUserGuide.data.content_banner_details_contact.content_spot_contents[0].article_detail;
  
              const parser = new DOMParser();
              const doc = parser.parseFromString(rawHTML, "text/html");
  
              const cleanHTML = doc.body.innerHTML;
  
              setIsUseGuideData(cleanHTML);
              setLoading(false);
          } catch (e) {
              console.error("e");
              setLoading(false);
          }
      };
      userGuideDataFetch();
  }, []);
  
    return (
        <>
          {loading && <Loader />}
      
          <BreadCrumbSecttion
            pageTitle="Redemption Catalogue"
            currentPageName="Redemption Catalogue"
          />
      
          <section className="padTop50">
            <div className="dashboard-details">
              <Container>
                <Row>
                  <Col xs={12}>
                    <section className="padTop50">
                      <div className="userInfoBox">
                        <Card className="p-3">
                          <h4 className="mb-4">Redemption Catalogue</h4>
      
                          {imgData && imgData.length > 0 ? (
                            imgData.map((item, index) => (
                              <div key={index} style={{ marginBottom: '40px', textAlign: 'center' }}>
                                <img
                                  src={item.file_path}
                                  alt={item.alt_text}
                                  style={{
                                    width: '100%',
                                    maxWidth: '800px',
                                    height: 'auto',
                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                  }}
                                />
                                <p className="mt-2 text-muted">{item.alt_text}</p>
                              </div>
                            ))
                          ) : (
                            <p>No catalogue items found.</p>
                          )}
      
                        </Card>
                      </div>
                    </section>
                  </Col>
                </Row>
              </Container>
            </div>
          </section>
        </>
      );
      
      
    }
    

export default RedemptionBrochure